import { CustomFieldDataType, FileRecordType, PersonRecordType } from "../SharedRecords.types";

export enum FieldTypeEnum {
  Text = "TEXT",
  TextArea = "TEXTAREA",
  Richtext = "RICHTEXT",
}

export enum WidthEnum {
  OneFourthWidth = "1/4",
  OneThirdWidth = "1/3",
  HalfWidth = "1/2",
  TwoThirdWidth = "2/3",
  ThreeFourthWidth = "3/4",
  FullWidth = "1/1",
}

export type DescriptionFieldType = {
  id: number;
  field_type: FieldTypeEnum;
  label: string;
  position: number;
  show_per_default: boolean;
  soft_required: boolean;
  slug: string;
  width: WidthEnum;
};

export type DescriptionType = {
  id?: number;
  text: string;
  slug: string;
};

export type EventBaseMetaType = {
  category_names: string[];
  contact_persons?: PersonRecordType[];
  context_names: string[];
  group_parent?: string;
};

export type EventBaseRecordType = {
  archived_at?: Date | string;
  audiences: number[];
  categories: number[];
  contact_persons: number[];
  contexts: number[];
  created_at: Date | string;
  custom_fields_data: CustomFieldDataType;
  descriptions: DescriptionType[];
  event_type: number;
  event_type_name: string;
  events: number[];
  files: FileRecordType[];
  documents: FileRecordType[];
  image: FileRecordType | null;
  group_children: number[];
  group_parent?: number;
  id: number;
  meta: EventBaseMetaType;
  name: string;
  partners: [];
  slug: string;
  summary: string;
  tags: string[];
  updated_at: Date | string;
  external_url: string | null;
};
